export default __webpack_public_path__ + "static/media/portrait4.c9d32166.png";